export const REPORT_TYPES = ["pdf", "xlsx", "xls", "csv", "docx"] as const;
export type ReportType = (typeof REPORT_TYPES)[number];

export const REPORT_EVENT_STATUSES = ["success", "failed"] as const;
export type ReportEventStatus = (typeof REPORT_EVENT_STATUSES)[number];

export interface ReportTemplate {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
}

export interface ReportTemplateDetail extends ReportTemplate {
    html: string;
}

export interface ReportUsageSummary {
    total: number;
    success: number;
    failed: number;
    success_rate: number;
    by_type: Partial<Record<ReportType, number>>;
}

export interface ReportUsagePoint {
    date: string;
    count: number;
}

export interface ReportUsageEvent {
    id: string;
    createdAt: string;
    reportType: ReportType;
    template: string;
    status: ReportEventStatus;
    sizeBytes: number;
}

export interface ReportColumn {
    key: string;
    label: string;
}

/** Mesmo contrato do `ReportRequest` que o backend envia ao report-service. */
export type ReportRequest =
    | { type: "pdf"; template: string; name: string; location: string; data: Record<string, unknown> }
    | {
          type: Exclude<ReportType, "pdf">;
          template: string;
          name: string;
          location: string;
          columns: ReportColumn[];
          rows: Record<string, unknown>[];
      };

export interface ReportFile {
    blob: Blob;
    filename: string;
}
